const SEPARATORS = /[_.-]+/;

export const trimWhitespaces = (string) =>
  string.split(' ').filter(Boolean).join(' ');

export const capitalize = (string) => {
  if (string.length === 0) {
    return '';
  }

  const firstLetter = string.slice(0, 1);
  const rest = string.slice(1);

  return `${firstLetter.toLocaleUpperCase()}${rest.toLocaleLowerCase()}`;
};

export const camelCase = (string) =>
  string
    .replaceAll(/([A-Z])/g, '_$1')
    .split(SEPARATORS)
    .filter((value) => value.length)
    .map((value, index) =>
      index === 0 ? value.toLocaleLowerCase() : capitalize(value)
    )
    .join('');

export const snakeCase = (string) =>
  string
    .replaceAll(/([A-Z])/g, '_$1')
    .split(SEPARATORS)
    .filter((value) => value.length)
    .map((value) => value.toLocaleLowerCase())
    .join('_');
